import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MagicLinkPage } from '@/features/auth';

/**
 * Landing page of the emailed sign-in link. No redirect for a signed-in visitor: the link may be
 * for another account, and exchanging it replaces the session cookie.
 */
export const Route = createFileRoute('/(public)/magic-link')({
  validateSearch: z.object({
    token: z.string().optional(),
    organization: z.string().optional(),
  }),
  component: MagicLinkRoute,
});

function MagicLinkRoute() {
  const { token, organization } = Route.useSearch();
  return <MagicLinkPage token={token} organization={organization} />;
}
